export const PASSWORD_REQUIREMENTS_REGEX =
  /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$&+,:;=?@#|'<>.^*()%!-])/;
